import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-type-7-bold text-right mb-0 mt-1" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Source: ")
const _hoisted_3 = ["href", "aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("p", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("a", {
      href: _ctx.href,
      target: "_blank",
      class: "metric-source text-type-7",
      "aria-label": `Open ${_ctx.metric.metric} source data`
    }, _toDisplayString(_ctx.metric.source), 9, _hoisted_3)
  ]))
}